import type { ListBuilderList } from '../../../types';
import { createShopPurchasedTogetherColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_PURCHASED_TOGETHER_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Purchased Together list configuration
 * Items frequently bought together - recommended based on cart contents
 */
export const shopPurchasedTogetherList: ListBuilderList = {
	id: 'shop_purchased_together',
	cacheTTL: 600000,
	name: 'Purchased Together',
	type: 'default',
	active: true,
	sortOrder: 5,
	columns: createShopPurchasedTogetherColumns(),
	description: 'Items recommended based on cart contents',
	defaultSortId: 'column-item_details-asc',
	requiredFields: SHOP_PURCHASED_TOGETHER_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'purchased_together',
					label: 'Purchased Together',
				},
			],
		},
	},
};
